var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20142 11.85C2.58879 11.6458 2.58292 11.316 3.21315 11.1059L25.6139 3.63941C26.2347 3.43286 26.5903 3.78025 26.4166 4.38818L20.0157 26.7877C19.8397 27.4086 19.4817 27.4297 19.2189 26.8405L15.0009 17.3484L22.0426 7.95948L12.6537 15.0011L3.20142 11.85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.d18b1dd02a12d8eb66ca0a5dd91cba9b.svg";
export { ForwardRef as ReactComponent };